// extracted by mini-css-extract-plugin
module.exports = {"root":"seller-inline_root__2vNRT","avatar":"seller-inline_avatar__3ayyh","name":"seller-inline_name__39fAo","pre":"seller-inline_pre__IqHrW"};